import { SetupAuth } from "../../client";

export type ClientAmbient = "prod" | "hml";

export interface ClientRcRow {
  id: number;
  slug: string;
  clientName: string;
  ambient?: ClientAmbient;
}

export interface ClientForceRow {
  id: number;
  slug: string;
  clientName: string;
  tenantId: string | null;
  clientIdForce: string | null;
  ambient?: ClientAmbient;
}

export async function fetchClientsRc(token: string): Promise<ClientRcRow[]> {
  const api = SetupAuth(token);
  const { data } = await api.get<{ status: number; clients?: ClientRcRow[]; error?: string }>("/clients-rc");
  if (data.status !== 200 || !data.clients) throw new Error(data.error || "Erro ao buscar clientes RC");
  return data.clients;
}

export async function fetchClientsForce(token: string): Promise<ClientForceRow[]> {
  const api = SetupAuth(token);
  const { data } = await api.get<{ status: number; clients?: ClientForceRow[]; error?: string }>("/clients-force");
  if (data.status !== 200 || !data.clients) throw new Error(data.error || "Erro ao buscar clientes Force");
  return data.clients;
}

export async function createClientRc(
  token: string,
  payload: { slug: string; clientName: string; ambient?: ClientAmbient }
): Promise<ClientRcRow> {
  const api = SetupAuth(token);
  const { data } = await api.post<{ status: number; client?: ClientRcRow; error?: string }>("/clients-rc", payload);
  if (data.status !== 201 || !data.client) throw new Error(data.error || "Erro ao criar cliente RC");
  return data.client;
}

export async function updateClientRc(
  token: string,
  id: number,
  payload: { slug?: string; clientName?: string; ambient?: ClientAmbient }
): Promise<ClientRcRow> {
  const api = SetupAuth(token);
  const { data } = await api.put<{ status: number; client?: ClientRcRow; error?: string }>(`/clients-rc/${id}`, payload);
  if (data.status !== 200 || !data.client) throw new Error(data.error || "Erro ao atualizar cliente RC");
  return data.client;
}

export async function deleteClientRc(token: string, id: number): Promise<void> {
  const api = SetupAuth(token);
  const { data } = await api.delete<{ status: number; error?: string }>(`/clients-rc/${id}`);
  if (data.status !== 200) throw new Error(data.error || "Erro ao remover cliente RC");
}

export async function createClientForce(
  token: string,
  payload: {
    slug: string;
    clientName: string;
    tenantId?: string | null;
    clientIdForce?: string | null;
    ambient?: ClientAmbient;
  }
): Promise<ClientForceRow> {
  const api = SetupAuth(token);
  const { data } = await api.post<{ status: number; client?: ClientForceRow; error?: string }>("/clients-force", payload);
  if (data.status !== 201 || !data.client) throw new Error(data.error || "Erro ao criar cliente Force");
  return data.client;
}

export async function updateClientForce(
  token: string,
  id: number,
  payload: {
    slug?: string;
    clientName?: string;
    tenantId?: string | null;
    clientIdForce?: string | null;
    ambient?: ClientAmbient;
  }
): Promise<ClientForceRow> {
  const api = SetupAuth(token);
  const { data } = await api.put<{ status: number; client?: ClientForceRow; error?: string }>(`/clients-force/${id}`, payload);
  if (data.status !== 200 || !data.client) throw new Error(data.error || "Erro ao atualizar cliente Force");
  return data.client;
}

export async function deleteClientForce(token: string, id: number): Promise<void> {
  const api = SetupAuth(token);
  const { data } = await api.delete<{ status: number; error?: string }>(`/clients-force/${id}`);
  if (data.status !== 200) throw new Error(data.error || "Erro ao remover cliente Force");
}
